import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/navbar.module.css';
import Gradify from '../assets/gradify.svg'; // Adjust path based on your folder
import GradifyLogo from 'assets/Gradify';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <GradifyLogo />
        </Link>
        <button className={styles.hamburger} onClick={toggleMenu}>
          <span className={styles.hamburgerLine}></span>
          <span className={styles.hamburgerLine}></span>
          <span className={styles.hamburgerLine}></span>
        </button>
        <div className={`${styles.nav} ${isMenuOpen ? styles.open : ''}`}>
          <Link to="/" className={styles.navLink} onClick={toggleMenu}>
            Home
          </Link>
          <Link to="/programs" className={styles.navLink} onClick={toggleMenu}>
            Programs
          </Link>
          <Link to="/about" className={styles.navLink} onClick={toggleMenu}>
            About
          </Link>
          <Link to="/contact" className={styles.navLink} onClick={toggleMenu}>
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
